import React from "react";

class PontifexTos extends React.Component {
	render() {
		return (
			<div>
				<div className="App-header">
					<h1>Pontifex Terms of Service</h1>
				</div>
				<main>
					<div className="Boxed">
						<p>
							Pontifex does not come with a warranty, any and all issues that occur with the bot are the responsibility of the user.<br></br>
							While support will be attempted to be given in a timely manner, there is no guarantee of support or assistance.<br></br>
							Access can be revoked at any time, without warning. Primarily when actions are judged to be misuse or abuse of the bot<br></br>
							<br></br><br></br>

							If you need to contact the bot support team or owner in any way <br></br> 
							Either contact us via email at <a href="mailto:pontifex@wrac4242.com">pontifex@wrac4242.com</a> <br></br>
							or join the support server <a href="https://discord.gg/eNRsbGv8y2">here</a> and ask to contact a bot support member
						</p>
					</div>
				</main>
			</div>
		);
	}
}

export default PontifexTos;
